export const DASHBOARD = Object.freeze({
    ASSETS: 'assets',
    ANALYTICS: 'analytics',
    ASSETS_LIST: 'assets/list',
    ASSETS_MAP: 'assets/map',
    ASSETS_SUMMARY: 'assets/summary',
  });